/**
 * Vuex getters for the "home" module.
 *
 * Thin state accessors — most simply expose a field from store.js under a
 * `getXyz` name. Documented here only where the mapping isn't 1:1 with the
 * state field name, or where the getter does real work.
 */
export default {
  getRecommendedPosts: state => state.recommendedPosts,
  getSuggestedPosts: state => state.suggestedPosts,
  getRecommendedPost: state => state.recommendedPost,
  getFollowingPosts: state => state.followingPosts,
  //getForYouPosts: (state) => state.forYouPosts,
  getRepliesPosts: state => state.replies,
  getPost: state => state.post,
  getCurrentTime: state => state.now,
  getProfile: state => state.profile,
  getUserReplies: state => state.userReplies,
  getUserReposts: state => state.userReposts,
  getOnlyUserPosts: state => state.onlyUserPosts,
  getReputationCategories: state => state.reputationCategories,
  getLoadStatus: state => state.loadStatus,
  getIsRouteLoading: state => state.isRouteLoading,
  getReportPostId: state => state.reportId,
  getIsReply: state => state.isReply,
  getUsernameData: state => state.usernameData,
  getReplyPostStatus: state => state.replyPostStatus,
  getTotalCountPosts: state => state.totalCountPosts,
  getPositivePosts: state => state.positive,
  getNegativePosts: state => state.negative,
  getAllFollowPosts: state => state.allFollowPosts,
  // Method-style getter: count of replies excluding those from blocked authors.
  // Call as getRepliesCount(blockedUsersIds) from a component.
  getRepliesCount: state => blockedUsersIds => {
    return state.replies.filter(reply => {
      return !blockedUsersIds.includes(reply.authorUserId);
    }).length;
  },
  getSearchText: state => state.searchText,
  getSearchUsers: state => state.searchResults.users,
  getSearchPosts: state => state.searchResults.posts,
  getSearchGroups: state => state.searchResults.groups,
  getUnreadPosts: state => state.unreadPosts,
  getNoSearchResults: state => state.noSearchResults,
  getIntroPosts: state => state.introPosts,
};
